import { Button } from 'component/Button'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { opt } from 'store/opt'
import { store } from 'store/store'

export const RetakeButton = observer(() => {
  const onRetake = useLatestCallback(async () => {
    store.profile.common.retake(false)
  })

  return (
    <Button
      primary={!opt.basic}
      wide
      upper
      large={opt.basic}
      action={onRetake}
    >
      {i18n('RetakePhoto')}
    </Button>
  )
})
